import { api } from "../../api/client.js";
import type { Asset, Message, ReferenceItem, Session } from "../../api/types.js";

export type SessionDetail = {
  session: Session;
  messages: Message[];
  citationSources: ReferenceItem[];
  referencePoolSummary: { totalCount: number };
  assets: Asset[];
};

export type ReferencePoolPage = {
  items: ReferenceItem[];
  totalCount: number;
  nextCursor: string | null;
};

export type SessionPatch = {
  title?: string;
  projectId?: string | null;
  pinned?: boolean;
};

export async function listSessions(projectId?: string) {
  const query = projectId ? `?projectId=${encodeURIComponent(projectId)}` : "";
  const data = await api<{ sessions: Session[] }>(`/api/sessions${query}`);
  return data.sessions;
}

export async function getSessionDetail(sessionId: string) {
  return api<SessionDetail>(`/api/sessions/${sessionId}`);
}

export async function getSessionReferencePage(sessionId: string, cursor?: string | null, limit = 30) {
  const params = new URLSearchParams({ limit: String(limit) });
  if (cursor) params.set("cursor", cursor);
  return api<ReferencePoolPage>(`/api/sessions/${sessionId}/references?${params.toString()}`);
}

export async function getSessionReferenceSummary(sessionId: string) {
  return api<{ totalCount: number }>(`/api/sessions/${sessionId}/reference-summary`);
}

export async function createSession(input: { projectId?: string | null; title?: string } = {}) {
  const data = await api<{ session: Session }>("/api/sessions", {
    method: "POST",
    body: JSON.stringify(input)
  });
  return data.session;
}

export async function updateSession(sessionId: string, patch: SessionPatch) {
  const data = await api<{ session: Session }>(`/api/sessions/${sessionId}`, {
    method: "PATCH",
    body: JSON.stringify(patch)
  });
  return data.session;
}

export async function deleteSession(sessionId: string) {
  await api(`/api/sessions/${sessionId}`, { method: "DELETE" });
}
